import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-merchant",
  "use": "icon-merchant-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-merchant\"><defs><style type=\"text/css\"></style></defs><path d=\"M336 256m-192 0a192 192 0 1 0 384 0 192 192 0 1 0-384 0Z\" p-id=\"8676\" /><path d=\"M336 544.256c25.28 0 49.088 2.304 71.488 7.04-0.64 4.48-0.896 9.088-0.896 13.632v214.144c0 18.816 4.736 36.928 13.312 52.928H51.264a19.2 19.2 0 0 1-18.432-24.32c49.024-175.488 150.08-263.296 303.168-263.424zM736 402.496l185.408 107.008a64 64 0 0 1 32 55.424v214.144a64 64 0 0 1-32 55.424L736 941.44a64 64 0 0 1-64 0L486.592 834.56a64 64 0 0 1-32-55.424V564.928a64 64 0 0 1 32-55.424L672 402.56a64 64 0 0 1 64 0zM704 576a96 96 0 1 0 0 192 96 96 0 0 0 0-192z\" p-id=\"8677\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/merchant.svg
// module id = 8OX1
// module chunks = 60